"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalEvent = void 0;
const core_1 = require("flow-connect/core");
const common_1 = require("flow-connect/common");
const utils_1 = require("flow-connect/utils");
const ui_1 = require("flow-connect/ui");
class GlobalEvent extends core_1.Node {
    constructor() {
        super();
        this.eventId = -1;
    }
    setupIO(options) {
        this.addTerminals([
            {
                type: options.globalEventType === common_1.GlobalEventType.Emitter ? core_1.TerminalType.IN : core_1.TerminalType.OUT,
                name: options.globalEventType === common_1.GlobalEventType.Emitter ? "emit" : "receive",
                dataType: "event",
            },
        ]);
    }
    created(options) {
        this.globalEventName = options.globalEventName;
        this.globalEventType = options.globalEventType;
        const { width = 150, name = "Global Event", style = {}, state = {} } = options;
        this.width = width;
        this.name = name;
        this.style = Object.assign({ rowHeight: 10 }, style);
        this.state = Object.assign(Object.assign({}, GlobalEvent.DefaultState), state);
        this.setupUI();
        this.setupListeners();
    }
    process() { }
    setupUI() {
        this.eventInput = this.createUI("core/input", {
            propName: "name",
            height: 20,
            style: { type: ui_1.InputType.Text, grow: 0.6 },
        });
        this.ui.append(this.createUI("core/x-layout", {
            childs: [this.createUI("core/label", { text: "Event", style: { grow: 0.4 } }), this.eventInput],
            style: { spacing: 10 },
        }));
    }
    setupListeners() {
        if (this.globalEventType === common_1.GlobalEventType.Emitter) {
            this.inputs[0].on("event", (_, data) => this.flow.globalEvents.call(this.state.name, data));
        }
        else {
            this.eventId = this.flow.globalEvents.on(this.state.name, (data) => this.outputs[0].emit(data));
        }
        this.watch("name", (prevVal) => {
            this.flow.globalEvents.off(prevVal, this.eventId);
            this.eventId = this.flow.globalEvents.on(this.state.name, (data) => this.outputs[0].emit(data));
        });
    }
}
exports.GlobalEvent = GlobalEvent;
GlobalEvent.DefaultState = { name: (0, utils_1.uuid)() };
